import React, { useContext } from "react";
import { Navbar, Nav } from "react-bootstrap";
import adminlogo from "../../images/Admin-logo.svg";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Button } from "./Button";
import { ModalContext } from "../../context/ModalContext";

const Sidenavigation = (props) => {
  const { setShowAddShortcutModal } = useContext(ModalContext);
  const location = useLocation();

  return (
    <div className="sidenavigation">
      <div className="logo">
        <Link to="/dashboard">
          <img src={adminlogo} alt="logo" />
        </Link>
      </div>
      <div className="add-profile">
        <Button
          onClick={() => setShowAddShortcutModal(true)}
          bg="indigo"
          width="211px"
          padding="15px"
          fontSize="sm"
          className="tour-add"
        >
          Add
        </Button>
      </div>
      <Navbar>
        <Nav className="me-auto">
          <NavLink
            to="/dashboard"
            activeClassName="active"
            className="tour-dashboard"
          >
            <span className="icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="none"
                viewBox="0 0 16 16"
              >
                <path
                  className="light"
                  fill="#989DB2"
                  fillRule="evenodd"
                  d="M14.5 10.5h-4v4h4v-4zm-4-1.5h4a1.5 1.5 0 011.5 1.5v4a1.5 1.5 0 01-1.5 1.5h-4A1.5 1.5 0 019 14.5v-4A1.5 1.5 0 0110.5 9zM5.5 1.5h-4v4h4v-4zm9 0h-4v4h4v-4zm-9 9h-4v4h4v-4zM5.5 0h-4A1.5 1.5 0 000 1.5v4A1.5 1.5 0 001.5 7h4A1.5 1.5 0 007 5.5v-4A1.5 1.5 0 005.5 0zm9 0h-4A1.5 1.5 0 009 1.5v4A1.5 1.5 0 0010.5 7h4A1.5 1.5 0 0016 5.5v-4A1.5 1.5 0 0014.5 0zm-13 9h4A1.5 1.5 0 017 10.5v4A1.5 1.5 0 015.5 16h-4A1.5 1.5 0 010 14.5v-4A1.5 1.5 0 011.5 9z"
                  clipRule="evenodd"
                ></path>
              </svg>
            </span>
            <span className="menu-name">
              <span>Dashboard</span>
              <span className="active-title">
                View your council permformance
              </span>
            </span>
          </NavLink>
          <NavLink
            to="/posts"
            className={
              location.pathname === "/posts" ||
              location.pathname === "/create-post" ||
              location.pathname.includes("/edit-post")
                ? "active tour-posts"
                : "tour-posts"
            }
          >
            <span className="icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="none"
                viewBox="0 0 16 16"
              >
                <path
                  className="light"
                  fill="#989DB2"
                  fillRule="evenodd"
                  d="M13.182 1.5a1.319 1.319 0 00-.933.386L11.076 3.06l1.865 1.865 1.173-1.173a1.318 1.318 0 00-.932-2.251zM11.88 5.984L10.016 4.12l-7.498 7.497-.7 2.564 2.565-.7 7.497-7.497zm.223-5.77a2.819 2.819 0 013.072 4.597l-9.873 9.872a.75.75 0 01-.333.194L.947 15.974a.75.75 0 01-.92-.921l1.096-4.022a.75.75 0 01.194-.333L11.189.825c.261-.261.572-.469.914-.61z"
                  clipRule="evenodd"
                ></path>
              </svg>
            </span>
            <span className="menu-name">
              <span>Post</span>
              <span className="active-title">Talk with your public</span>
            </span>
          </NavLink>
          <NavLink
            to="/event"
            className={
              location.pathname === "/event" ||
              location.pathname === "/create-event" ||
              location.pathname.includes("/edit-event") ||
              location?.pathname?.includes("/event-details")
                ? "active tour-events"
                : "tour-events"
            }
          >
            <span className="icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="none"
                viewBox="0 0 16 16"
              >
                <g clipPath="url(#clip0)">
                  <path
                    className="light"
                    fill="#989DB2"
                    d="M2.932 0h.219c.28.11.386.318.368.611-.01.128 0 .253 0 .381h.92c0-.131.006-.256 0-.377-.022-.29.084-.503.365-.615h.218c.281.11.387.321.368.615-.009.121 0 .246 0 .374h5.207c0-.137.01-.262-.003-.384-.025-.287.084-.493.356-.605h.218c.274.103.39.306.371.593-.01.13 0 .265 0 .402h.927c0-.134.009-.265-.004-.393-.021-.287.088-.493.36-.602h.218c.283.106.39.318.37.611-.009.128 0 .256 0 .39.294 0 .565-.003.834 0 .346.003.664.103.942.319.424.33.608.767.608 1.304-.003 3.908-.003 7.817-.003 11.726 0 .068.01.137-.006.203-.04.18-.066.374-.144.536-.29.593-.783.883-1.438.883-3.369.003-6.735 0-10.104 0-.78 0-1.56.012-2.34-.006a1.765 1.765 0 01-.705-.16c-.592-.286-.867-.785-.867-1.434V2.614c0-.056 0-.115.003-.171.028-.609.465-1.195 1.052-1.348.287-.075.592-.069.892-.09C2.277.994 2.42 1 2.57 1c0-.15.007-.274 0-.399C2.552.315 2.66.11 2.932 0zM1.13 4.932v9.399c0 .471.225.699.699.699h12.331c.465 0 .69-.225.69-.69V5.094v-.162H1.129zm10.407-2.976c0 .162.006.318-.003.471a.778.778 0 01-.06.268.444.444 0 01-.492.244.442.442 0 01-.38-.412c-.013-.19-.004-.38-.004-.568H5.384v.243c0 .085.003.166 0 .25-.01.25-.14.424-.35.48-.311.081-.582-.13-.598-.477-.006-.165 0-.33 0-.502h-.899c-.009.019-.018.025-.018.034-.003.156 0 .312-.006.468-.01.24-.138.415-.337.471a.458.458 0 01-.596-.402c-.016-.187-.003-.378-.003-.562-.05-.012-.066-.019-.078-.019-.24 0-.478-.003-.718 0-.424.007-.655.238-.655.662-.003.412 0 .82 0 1.232 0 .044.006.09.01.137h13.7c0-.518.013-1.026-.006-1.531a.507.507 0 00-.45-.475c-.317-.021-.639-.006-.979-.006 0 .15.007.3-.003.446a.856.856 0 01-.059.284.444.444 0 01-.493.243c-.206-.037-.365-.19-.377-.396-.013-.193-.003-.39-.003-.586-.325.003-.618.003-.93.003z"
                  ></path>
                  <path
                    className="dark"
                    fill="#fff"
                    d="M2.932 0c-.271.11-.38.315-.362.602.01.125 0 .25 0 .4-.15 0-.293-.01-.436.003-.3.022-.605.015-.892.09-.587.153-1.024.74-1.052 1.348-.003.056-.003.115-.003.171v11.758c0 .649.275 1.148.864 1.432.212.103.468.152.705.159.78.019 1.56.006 2.34.006H14.2c.658 0 1.151-.287 1.438-.883.081-.162.103-.356.144-.536.015-.066.006-.135.006-.203 0-3.909 0-7.818.003-11.726 0-.534-.184-.974-.608-1.304a1.507 1.507 0 00-.942-.319c-.269-.003-.54 0-.833 0 0-.134-.007-.262 0-.39.018-.293-.088-.505-.371-.61H16v16H0V0h2.932z"
                  ></path>
                  <path
                    className="dark"
                    fill="#fff"
                    d="M10.95 0c-.269.112-.378.318-.356.605.01.122.003.247.003.384H5.391c0-.128-.007-.253 0-.374C5.409.32 5.303.109 5.022 0h5.928zM12.818 0c-.268.112-.38.315-.359.602.01.128.003.256.003.393h-.926c0-.134-.006-.268 0-.402.019-.29-.097-.49-.371-.593h1.653zM4.804 0c-.278.112-.384.324-.365.615.01.121 0 .246 0 .377h-.92c0-.128-.006-.256 0-.38C3.538.317 3.43.108 3.15 0h1.653zM1.13 4.932h13.719V14.34c0 .462-.225.69-.69.69H1.829c-.471 0-.699-.225-.699-.699v-9.23-.17zm6.865 8.788a3.755 3.755 0 003.734-3.747 3.746 3.746 0 00-3.756-3.737c-2.065.012-3.743 1.7-3.73 3.75.015 2.061 1.706 3.746 3.752 3.734zM11.536 1.956h.933c0 .2-.01.393.003.586a.44.44 0 00.377.397.448.448 0 00.493-.244.81.81 0 00.06-.284c.009-.15.003-.3.003-.446.337 0 .66-.015.98.007a.51.51 0 01.448.474c.019.508.006 1.017.006 1.531H1.14c-.004-.046-.01-.09-.01-.137 0-.412-.003-.82 0-1.232.003-.424.231-.655.655-.661.24-.004.478 0 .718 0 .015 0 .031.006.078.018 0 .181-.013.375.003.562a.46.46 0 00.596.402c.2-.056.327-.234.337-.47.006-.157.003-.313.006-.469 0-.01.01-.018.019-.034h.898c0 .172-.006.337 0 .502.016.343.287.559.599.477.206-.053.337-.23.35-.48.003-.084 0-.165 0-.25v-.243H10.6c0 .19-.01.38.003.568a.44.44 0 00.38.412.444.444 0 00.494-.244.783.783 0 00.059-.268c.01-.156 0-.312 0-.474z"
                  ></path>
                  <path
                    className="light"
                    fill="#989DB2"
                    d="M7.995 13.72c-2.046.009-3.737-1.672-3.752-3.734-.013-2.05 1.665-3.738 3.73-3.75 2.063-.013 3.75 1.669 3.756 3.737a3.753 3.753 0 01-3.734 3.747zM5.188 9.954c-.038 1.51 1.207 2.792 2.776 2.817 1.522.025 2.786-1.182 2.826-2.751.041-1.522-1.204-2.808-2.751-2.845-1.544-.034-2.81 1.2-2.851 2.78z"
                  ></path>
                  <path
                    className="dark"
                    fill="#fff"
                    d="M5.188 9.954c.04-1.578 1.307-2.813 2.848-2.776 1.547.034 2.792 1.323 2.751 2.845-.04 1.566-1.304 2.776-2.826 2.751-1.566-.028-2.81-1.313-2.773-2.82zm2.433.197c-.2-.203-.396-.396-.59-.59-.115-.118-.252-.184-.42-.159a.445.445 0 00-.381.303.453.453 0 00.115.502c.293.296.587.59.88.883.268.265.518.268.783.003.52-.521 1.042-1.042 1.566-1.563.028-.028.06-.06.084-.09a.476.476 0 00.06-.524c-.094-.175-.285-.287-.481-.238a.727.727 0 00-.328.19c-.43.419-.851.846-1.288 1.283z"
                  ></path>
                  <path
                    className="light"
                    fill="#989DB2"
                    d="M7.621 10.15c.437-.436.858-.866 1.288-1.284a.757.757 0 01.328-.19c.196-.05.387.062.48.236a.476.476 0 01-.059.525c-.025.03-.056.062-.084.09-.521.52-1.042 1.045-1.566 1.563-.265.262-.515.262-.783-.003-.293-.293-.59-.587-.88-.883a.458.458 0 01-.115-.502.44.44 0 01.38-.303c.169-.025.303.04.421.16l.59.592z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0">
                    <path fill="#fff" d="M0 0H16V16H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            </span>

            <span className="menu-name">
              <span>Events</span>
              <span className="active-title">Talk with your customers</span>
            </span>
          </NavLink>
          {/* <NavLink to="/users" className="tour-users">
            <span className="icon">
              <img src={User} alt="dashboard" />
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="none"
                viewBox="0 0 20 20"
              >
                <path
                  className="light"
                  fill="#989DB2"
                  fillRule="evenodd"
                  d="M12.27 5.733c0 1.22-1.003 2.234-2.27 2.234-1.267 0-2.27-1.014-2.27-2.234S8.734 3.5 10 3.5c1.267 0 2.27 1.013 2.27 2.233zm1.5 0c0 2.062-1.688 3.734-3.77 3.734S6.23 7.795 6.23 5.733C6.23 3.671 7.919 2 10 2s3.77 1.671 3.77 3.733zm-5.307 6.3h3.074c2.132 0 3.963 1.818 3.963 4.19a.31.31 0 01-.082.217.17.17 0 01-.125.06H4.707a.17.17 0 01-.125-.06.31.31 0 01-.082-.218c0-2.371 1.831-4.189 3.963-4.189zM3 16.223c0-3.143 2.446-5.69 5.463-5.69h3.074c3.017 0 5.463 2.547 5.463 5.69 0 .981-.764 1.777-1.707 1.777H4.707C3.764 18 3 17.204 3 16.222z"
                  clipRule="evenodd"
                ></path>
              </svg>
            </span>

            <span className="menu-name">
              <span>Users</span>
              <span className="active-title">View Whatzon users</span>
            </span>
          </NavLink> */}
          <NavLink
            to="/attractions"
            className={
              location.pathname === "/create-attraction" ||
              location.pathname === "/attractions" ||
              location.pathname.includes("/edit-attraction") ||
              location.pathname.includes("attraction")
                ? "active tour-attraction"
                : "tour-attraction"
            }
          >
            <span className="icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="17"
                height="17"
                fill="none"
                viewBox="0 0 17 17"
              >
                <path
                  className="light"
                  fill="#989DB2"
                  d="M0 6.64V4.915c.109-.104.208-.226.335-.303C2.621 3.245 4.912 1.887 7.203.53c.349-.213.688-.444 1.1-.53h.398c.195.072.408.122.584.226 2.495 1.471 4.985 2.951 7.475 4.431.168.1.25.236.25.435-.006.466 0 .928 0 1.394 0 .321-.146.462-.467.466-.3.005-.598 0-.897 0-.059 0-.117.005-.172.01V13.9c.064.009.118.018.172.022.73.104 1.264.62 1.336 1.349.04.398.023.806.023 1.209.004.384-.132.515-.521.515-5.324 0-10.644 0-15.968.005-.24 0-.416-.072-.511-.303V15.27c.009-.018.022-.036.027-.059.086-.502.344-.882.801-1.109.217-.108.466-.158.71-.235V6.957c-.357 0-.7-.005-1.05 0C.25 6.957.081 6.87 0 6.64zm16.23-.47c0-.272-.004-.54.005-.802.004-.1-.036-.15-.118-.195L8.932.91a.79.79 0 00-.86-.005L.874 5.182c-.041.023-.095.064-.095.1-.01.294-.005.593-.005.887H16.23zM.792 16.211h15.416c0-.312.027-.62-.01-.918-.04-.317-.257-.516-.57-.593a1.435 1.435 0 00-.312-.027H1.689c-.104 0-.213.004-.313.027-.312.077-.534.276-.57.593-.04.303-.014.606-.014.918zm6.153-2.317V6.961h-2.29v6.934h2.29zm3.11-6.93V13.9h2.3V6.966h-2.3zm-7.719-.004v6.934h1.521V6.961h-1.52zm5.41 0v6.93h1.517V6.96H7.746zm6.922 6.948V6.966h-1.516v6.938c.045 0 .077.005.109.005h1.407z"
                ></path>
                <path
                  className="dark"
                  fill="#fff"
                  d="M0 6.64c.082.23.249.321.484.316.349-.004.693 0 1.05 0v6.912c-.244.081-.493.127-.71.235-.453.226-.715.611-.801 1.11-.005.022-.018.04-.028.058C0 12.392 0 9.514 0 6.64z"
                ></path>
                <path
                  className="light"
                  fill="#989DB2"
                  d="M10.037 3.793c.063.828-.589 1.557-1.476 1.607a1.52 1.52 0 01-1.584-1.34 1.544 1.544 0 011.408-1.733 1.542 1.542 0 011.652 1.466zm-.77.063a.772.772 0 00-.774-.765.772.772 0 00.014 1.543.769.769 0 00.76-.778z"
                ></path>
                <path
                  className="dark"
                  fill="#fff"
                  d="M9.267 3.856a.769.769 0 01-.76.778.766.766 0 01-.774-.765.769.769 0 01.76-.778c.421-.005.77.34.774.765z"
                ></path>
              </svg>
            </span>
            <span className="menu-name">
              <span>Attractions</span>
              <span className="active-title">Manage Council Attractions</span>
            </span>
          </NavLink>
          <NavLink
            to="/council-profile"
            className={
              location.pathname === "/council-profile" ||
              location.pathname.includes("/edit-council-profile")
                ? "active tour-council-profile"
                : "tour-council-profile"
            }
          >
            <span className="icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="21"
                fill="none"
                viewBox="0 0 20 21"
              >
                <path
                  className="light"
                  fill="#989DB2"
                  fillRule="evenodd"
                  d="M8.55 3.357c-.583 0-1.142.23-1.555.642-.413.412-.645.97-.645 1.553v.694H4.2c-1.212 0-2.2.98-2.2 2.195v7.222c0 1.215.988 2.195 2.2 2.195h2.882a1.033 1.033 0 00.035 0H15.8c1.212 0 2.2-.98 2.2-2.195V8.441a2.197 2.197 0 00-2.2-2.195h-2.15v-.694c0-.583-.232-1.141-.645-1.553a2.202 2.202 0 00-1.555-.642h-2.9zm3.6 2.89v-.695a.692.692 0 00-.205-.49.702.702 0 00-.496-.205h-2.9a.703.703 0 00-.495.205.692.692 0 00-.204.49v.694h4.3zm-4.3 1.5h4.3v8.61h-4.3v-8.61zm-1.5 0H4.2c-.39 0-.7.313-.7.694v7.222c0 .381.31.695.7.695h2.15V7.746zm7.3 8.61v-8.61h2.15c.388 0 .699.313.699.694v7.222c0 .381-.31.695-.7.695h-2.15z"
                  clipRule="evenodd"
                ></path>
              </svg>
            </span>
            <span className="menu-name">
              <span>Council profile</span>
              <span className="active-title">View your business profile</span>
            </span>
          </NavLink>
          <Link
            to="/settings"
            className={
              location.pathname === "/settings" ||
              location.pathname === "/referrals-details"
                ? "active tour-settings"
                : "tour-settings"
            }
          >
            <span className="icon">
              <svg
                width="20"
                height="21"
                viewBox="0 0 20 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M2.30924 7.37855C1.57234 8.59012 2.27635 9.84169 3.12525 10.3066L3.29948 10.4017C3.29681 10.471 3.29503 10.5404 3.29414 10.607C3.29503 10.6737 3.29681 10.743 3.29948 10.8124L3.12525 10.9075C2.27635 11.3724 1.57234 12.6239 2.30924 13.8355L3.29325 15.4515C3.98126 16.5813 5.32172 16.632 6.14129 16.1831L6.29951 16.096C6.49685 16.224 6.70218 16.3431 6.91196 16.4533V16.4835C6.91196 17.5698 7.76975 18.6071 9.01599 18.6071H10.984C12.2302 18.6071 13.088 17.5698 13.088 16.4835V16.4533C13.2978 16.3431 13.5032 16.224 13.7005 16.096L13.8587 16.1831C14.6783 16.632 16.0187 16.5813 16.7067 15.4515L17.6908 13.8355C18.4277 12.6239 17.7236 11.3724 16.8747 10.9075L16.7005 10.8124C16.7032 10.743 16.705 10.6737 16.7059 10.607C16.705 10.5404 16.7032 10.471 16.7005 10.4017L16.8747 10.3066C17.7236 9.84169 18.4277 8.59012 17.6908 7.37855L16.7067 5.76253C16.0187 4.63274 14.6783 4.58296 13.8587 5.03096L13.7005 5.11807C13.5032 4.99007 13.2978 4.87096 13.088 4.76074V4.73051C13.088 3.64428 12.2302 2.60693 10.984 2.60693H9.01599C7.76975 2.60693 6.91196 3.64428 6.91196 4.73051V4.76074C6.70218 4.87096 6.49685 4.99007 6.29951 5.11807L6.14129 5.03096C5.32172 4.58296 3.98126 4.63274 3.29325 5.76253L2.30924 7.37855ZM6.46396 7.23454L5.28972 6.59098C5.1155 6.49587 4.90038 6.53854 4.80972 6.68787L3.8257 8.30389C3.73504 8.45323 3.80259 8.65056 3.97682 8.74656L5.21772 9.42568C5.12172 9.80346 5.07016 10.1999 5.07016 10.607C5.07016 11.0141 5.12172 11.4106 5.21772 11.7884L3.97682 12.4675C3.80259 12.5635 3.73504 12.7608 3.8257 12.9102L4.80972 14.5262C4.90038 14.6755 5.1155 14.7182 5.28972 14.6231L6.46396 13.9795C7.06663 14.5884 7.8302 15.0417 8.68798 15.2738V16.4835C8.68798 16.6747 8.83465 16.8293 9.01599 16.8293H10.984C11.1653 16.8293 11.312 16.6747 11.312 16.4835V15.2738C12.1698 15.0417 12.9334 14.5884 13.536 13.9795L14.7103 14.6231C14.8845 14.7182 15.0996 14.6755 15.1903 14.5262L16.1743 12.9102C16.265 12.7608 16.1974 12.5635 16.0232 12.4675L14.7823 11.7884C14.8783 11.4106 14.9298 11.0141 14.9298 10.607C14.9298 10.1999 14.8783 9.80346 14.7823 9.42568L16.0232 8.74656C16.1974 8.65056 16.265 8.45323 16.1743 8.30389L15.1903 6.68787C15.0996 6.53854 14.8845 6.49587 14.7103 6.59098L13.536 7.23454C12.9334 6.62565 12.1698 6.17231 11.312 5.9412V4.73051C11.312 4.5394 11.1653 4.38473 10.984 4.38473H9.01599C8.83465 4.38473 8.68798 4.5394 8.68798 4.73051V5.9412C7.8302 6.17231 7.06663 6.62565 6.46396 7.23454ZM9.99654 13.2737C11.4677 13.2737 12.6597 12.0799 12.6597 10.607C12.6597 9.13412 11.4677 7.94033 9.99654 7.94033C8.52541 7.94033 7.3334 9.13412 7.3334 10.607C7.3334 12.0799 8.52541 13.2737 9.99654 13.2737ZM11 10.6069C11 11.1589 10.5526 11.6069 10 11.6069C9.44745 11.6069 9 11.1589 9 10.6069C9 10.0549 9.44745 9.60693 10 9.60693C10.5526 9.60693 11 10.0549 11 10.6069Z"
                  fill="#989DB2"
                />
              </svg>
            </span>
            <span className="menu-name">
              <span>Settings</span>
              <span className="active-title">Talk with your customers</span>
            </span>
          </Link>
        </Nav>
      </Navbar>
    </div>
  );
};
export default Sidenavigation;
